interface FormationIconProps {
  category: string;
  className?: string;
}

export function FormationIcon({ category, className = "w-24 h-24" }: FormationIconProps) {
  const getCategoryIcon = () => {
    const categoryLower = category.toLowerCase();

    // SIG / QGIS
    if (categoryLower.includes('qgis') || categoryLower.includes('sig') || categoryLower.includes('géospatial')) {
      return (
        <svg viewBox="0 0 100 100" className={className} fill="none">
          <circle cx="50" cy="50" r="45" fill="#F06C6E" opacity="0.1" />
          <path d="M30 50L40 60L50 40L60 70L70 50" stroke="#F06C6E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="40" cy="60" r="3" fill="#F06C6E" />
          <circle cx="50" cy="40" r="3" fill="#F06C6E" />
          <circle cx="60" cy="70" r="3" fill="#F06C6E" />
          <circle cx="70" cy="50" r="3" fill="#F06C6E" />
          <path d="M25 75L75 75M30 70L30 75M40 65L40 75M50 70L50 75M60 60L60 75M70 68L70 75" stroke="#F06C6E" strokeWidth="1.5" opacity="0.5" />
        </svg>
      );
    }

    // Python / Data Science
    if (categoryLower.includes('python') || categoryLower.includes('data') || categoryLower.includes('r ')) {
      return (
        <svg viewBox="0 0 100 100" className={className} fill="none">
          <circle cx="50" cy="50" r="45" fill="#F06C6E" opacity="0.1" />
          <rect x="35" y="35" width="8" height="30" fill="#F06C6E" opacity="0.6" />
          <rect x="47" y="25" width="8" height="40" fill="#F06C6E" opacity="0.8" />
          <rect x="59" y="30" width="8" height="35" fill="#F06C6E" />
          <path d="M32 70L45 60L55 65L68 55" stroke="#F06C6E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="45" cy="60" r="2.5" fill="#F06C6E" />
          <circle cx="55" cy="65" r="2.5" fill="#F06C6E" />
          <circle cx="68" cy="55" r="2.5" fill="#F06C6E" />
        </svg>
      );
    }

    // Agriculture / Agronomie
    if (categoryLower.includes('agri') || categoryLower.includes('culture') || categoryLower.includes('agro')) {
      return (
        <svg viewBox="0 0 100 100" className={className} fill="none">
          <circle cx="50" cy="50" r="45" fill="#F06C6E" opacity="0.1" />
          <path d="M50 70V40M50 40C50 35 55 30 60 28M50 40C50 35 45 30 40 28" stroke="#F06C6E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <ellipse cx="50" cy="73" rx="12" ry="4" fill="#F06C6E" opacity="0.3" />
          <circle cx="55" cy="48" r="4" fill="#F06C6E" opacity="0.6" />
          <circle cx="45" cy="52" r="3.5" fill="#F06C6E" opacity="0.6" />
          <circle cx="54" cy="58" r="3" fill="#F06C6E" opacity="0.6" />
        </svg>
      );
    }

    // Numérique / Digital
    if (categoryLower.includes('numérique') || categoryLower.includes('digital') || categoryLower.includes('ia')) {
      return (
        <svg viewBox="0 0 100 100" className={className} fill="none">
          <circle cx="50" cy="50" r="45" fill="#6C5CE7" opacity="0.1" />
          <rect x="30" y="35" width="40" height="25" rx="2" stroke="#6C5CE7" strokeWidth="2.5" />
          <rect x="35" y="40" width="30" height="15" fill="#6C5CE7" opacity="0.2" />
          <path d="M40 65L50 72L60 65" stroke="#6C5CE7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="50" cy="28" r="2" fill="#6C5CE7" />
          <path d="M50 28V32" stroke="#6C5CE7" strokeWidth="1.5" />
        </svg>
      );
    }

    // Télédétection / Satellite
    if (categoryLower.includes('satellite') || categoryLower.includes('télédétection') || categoryLower.includes('drone')) {
      return (
        <svg viewBox="0 0 100 100" className={className} fill="none">
          <circle cx="50" cy="50" r="45" fill="#FF9500" opacity="0.1" />
          <circle cx="50" cy="45" r="8" stroke="#FF9500" strokeWidth="2.5" />
          <rect x="46" y="25" width="8" height="10" fill="#FF9500" opacity="0.6" />
          <rect x="30" y="41" width="10" height="8" fill="#FF9500" opacity="0.6" />
          <rect x="60" y="41" width="10" height="8" fill="#FF9500" opacity="0.6" />
          <path d="M50 55L50 70M50 70L40 75M50 70L60 75" stroke="#FF9500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="50" cy="45" r="3" fill="#FF9500" />
        </svg>
      );
    }

    // Default icon - Education
    return (
      <svg viewBox="0 0 100 100" className={className} fill="none">
        <circle cx="50" cy="50" r="45" fill="#F06C6E" opacity="0.1" />
        <path d="M50 30L70 40L50 50L30 40L50 30Z" fill="#F06C6E" opacity="0.6" />
        <path d="M30 40V55L50 65L70 55V40" stroke="#F06C6E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="75" cy="50" r="3" fill="#F06C6E" />
        <path d="M75 53V63" stroke="#F06C6E" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  };

  return getCategoryIcon();
}
